import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import { Section } from '@fiverr-private/layout_components';
import { mixpanel } from '@fiverr-private/obs';
import { logger } from '../../lib/logger';
import { trackPageMetaData, trackSignUp } from '../shared/gtmTracking';
import { createAffiliate } from './services/affiliate';
import PersonalInfo from './PersonalInfo';
import AdditionalInfo from './AdditionalInfo';
import RegistrationSuccess from './RegistrationSuccess';
import { PERSONAL_FIELDS } from './constants';

import { affiliatesFormClass } from './styles.ve.css';

const mapFormValues = (formData) => {
    const map = { ...formData };

    [PERSONAL_FIELDS.MAIN_SOURCE_OF_TRAFFIC, PERSONAL_FIELDS.COMPANY_NAME].forEach((field) => {
        map[field] = map[field] || null;
    });

    map[PERSONAL_FIELDS.HAS_SOURCE_OF_TRAFFIC] = map[PERSONAL_FIELDS.HAS_SOURCE_OF_TRAFFIC] === 'yes';

    return map;
};

const Form = ({ history }) => {
    const [formData, setFormData] = useState({});
    const [submitFailedReason, setSubmitFailedReason] = useState('');
    const [submitInProgress, setSubmitInProgress] = useState(false);

    useEffect(() => {
        trackPageMetaData();
    }, []);

    useEffect(() => {
        mixpanel.track('Affailites Registration - View');
    }, []);

    const getNumberFormFields = () => Object.keys(formData).length;

    const onFormEvent = ({ action, error, userId, ...data }) => {
        trackSignUp({
            action,
            formType: 'Sign-up',
            userId,
            formFields: getNumberFormFields(),
            formMessagesText: error,
            formMessagesType: error && 'error',
            ...data,
        });
    };

    const onAffiliateCreated = (affiliateId) => {
        logger.info('On affiliate created', { affiliateId });

        history.replace('/thank_you');

        mixpanel.track('Affailites Registration - Registeration Success', formData);

        onFormEvent({ action: 'Form Submit Successful', userId: affiliateId, formFields: 0 });
    };

    const onPersonalInfoSubmit = (personalInfo) => {
        logger.info('On personal info submit');

        history.replace('/additional_info');
        setFormData(Object.assign(formData, personalInfo));

        mixpanel.track('Affailites Registration - Next Button Click');
    };

    const PersonalInfoComponent = () => (
        <PersonalInfo
            formData={formData}
            onStart={(data) => onFormEvent({ action: 'Form Start', ...data })}
            onSubmit={onPersonalInfoSubmit}
        />
    );

    const onAdditionalInfoSubmit = (additionalInfo) => {
        logger.info('On additional info submit');

        mixpanel.track('Affailites Registration - Register Button Click');

        setFormData(Object.assign(formData, additionalInfo));
        onFormEvent({ action: 'Form Submit' });
        setSubmitFailedReason('');
        setSubmitInProgress(true);

        createAffiliate(mapFormValues(formData))
            .then(onAffiliateCreated)
            .finally(() => setSubmitInProgress(false))
            .catch((reason) => {
                setSubmitFailedReason(reason);
                onFormEvent({
                    action: 'Form Submit',
                    error: new Error('Signup request failed'),
                });
            });
    };

    const onAdditionalInfoBack = () => {
        setSubmitFailedReason('');
    };

    const AdditionalInfoComponent = () => (
        <AdditionalInfo
            submitInProgress={submitInProgress}
            formData={formData}
            submitFailedReason={submitFailedReason}
            onSubmit={onAdditionalInfoSubmit}
            onBack={onAdditionalInfoBack}
        />
    );

    const RegistrationSuccessComponent = () => <RegistrationSuccess />;

    return (
        <Section className={affiliatesFormClass} maxWidth={{ default: '100%', md: '50%' }} marginX="auto">
            <Route path="/" render={PersonalInfoComponent} exact />
            <Route path="/additional_info" render={AdditionalInfoComponent} />
            <Route path="/thank_you" render={RegistrationSuccessComponent} />
        </Section>
    );
};

Form.propTypes = {
    history: object,
};

export default withRouter(Form);
